import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BannerSliderMobile from 'components_v2/mobile/BannerSlider';
import AdCaller from 'helpers/ads/adCaller';
import s from './LoksabhaElectionResultWrapper.scss';
// import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';
// import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import HeaderTab from '../../../routes/home/components/desktop/HeaderTabV2/HeaderTab';
// import InfoMsg from '../../../components/ElectionV2/common/InfoMsg/InfoMsg';
import { loadLokSabhaResult } from '../../../components/ElectionV2/loksabha_redux';
import LoaderSpinner from '../LoaderSpinner/LoaderSpinner';
import BannerSlider from '../../desktop/BannerSlider/BannerSlider';
import ResultStateWidget from '../../../components/ElectionV2/lokSabha/ResultStateWidget/ResultStateWidget';
import SwitchTabs from '../../../components/ElectionV2/common/SwitchTabs/SwitchTabs';

class LoksabhaElectionStateResultWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.stateResultWrapRef = React.createRef();
    const { electionData } = this.props?.sectionData?.items || {};
    this.state = {
      activeTab: this.props.isStatesPage ? 2 : 1,
      expandDiv: false,
    };
    try {
      if (electionData) {
        const currentData = Object.values(electionData)
          .filter(e => e.resultUrl)
          .sort((a, b) => b.year - a.year)[0];
        if (currentData) {
          this.state.currentData = currentData;
        }
      }
    } catch (error) {
      //
    }
  }

  toggleClass = () => {
    if (this.state.expandDiv) {
      if (this.stateResultWrapRef.current) {
        this.stateResultWrapRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
    this.setState({ expandDiv: !this.state.expandDiv });
  };

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval && this.state?.currentData?.live) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.loadAjaxResultData(this.state?.currentData?.exitPollObject);
      }, refreshinterval * 1000);
    }
  };

  componentDidMount() {
    this.refreshData();
  }

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  onTabsChange = params => {
    const { exitPollObject } = params.clickedItem;
    this.setState({ currentData: params.clickedItem });
    this.props.loadAjaxResultData(exitPollObject, true);
  };

  setActiveTab = tabNum => {
    this.setState({
      activeTab: tabNum?.index ? Number(tabNum?.index) : this.state.activeTab,
    });
  };

  renderElection() {
    const { electionData } = this.props?.sectionData?.items || {};
    const {
      isWapView,
      states = [],
      sortedData,
      infoMsg,
      alMasterMap,
      prMasterMap,
      starCandidateData,
      datasource,
    } = this.props;
    const powerStates =
      (states &&
        Array.isArray(states) &&
        states.filter(str => str.powerState === '1')) ||
      [];

    const lokSabhaStateMap = sortedData?.states || {};

    const lokSabhaStates = Object.values(lokSabhaStateMap) || [];

    this.tabRefs = powerStates.reduce((acc, tab) => {
      acc[tab.key] = React.createRef();
      return acc;
    }, {});

    const { activeTab } = this.state;
    const tabs = [
      { name: 'Alliance View', index: 1 },
      { name: 'Party View', index: 2 },
    ];

    let { activeTabObject } = this.state;

    if (!activeTabObject && !isWapView) {
      activeTabObject = powerStates.slice(0, 1);
    } else if (!activeTabObject && isWapView) {
      activeTabObject = powerStates.slice(0, 1);
    }
    const currentActiveTab = activeTabObject;
    const slideIndex =
      powerStates instanceof Array &&
      powerStates.findIndex(
        st =>
          typeof st !== 'undefined' &&
          currentActiveTab &&
          Array.isArray(currentActiveTab) &&
          currentActiveTab.length > 0 &&
          st.key === currentActiveTab[0].key,
      );
    if (slideIndex > -1 && this.slider) {
      this.slider.slickGoTo(slideIndex);
    }

    return (
      <>
        <div className={s.switchTabsWrap} ref={this.stateResultWrapRef}>
          {!this.props.isStatesPage && (
            <SwitchTabs tabs={tabs} tabHandler={this.setActiveTab} />
          )}
          <div className={s.tabs}>
            <span>Year :</span>{' '}
            <HeaderTab
              subSections={Object.values(electionData)
                .filter(ed => ed.resultUrl)
                .sort((a, b) => b.year - a.year)
                .map(ed => ({
                  ...ed,
                  url: ed.resultUrl,
                  link: ed.resultUrl,
                }))}
              onChangeCallback={this.onTabsChange}
            />
          </div>
        </div>
        {!this.props.isStatesPage && (
          <ResultStateWidget
            powerStates={powerStates}
            lokSabhaStateMap={lokSabhaStateMap}
            lokSabhaStates={lokSabhaStates}
            sortedData={sortedData}
            infoMsg={infoMsg}
            isWapView={isWapView}
            datasource={datasource}
            alMasterMap={alMasterMap}
            prMasterMap={prMasterMap}
            stateName={this.props?.sectionData?.electionkey}
            starCandidateData={starCandidateData}
            stateResultPage
            activeTab={activeTab}
            candidateLinking={this.state?.currentData?.candidateLinking}
          />
        )}

        {this.props?.sectionData?.items?.banner && (
          <>
            <AdCaller data={{ jname: 'rsltdayewbottom' }} immediateLoad />
            <div
              className={`${s.bannerSliderWrap} ${!isWapView ? s.mb24 : ''}`}
            >
              {!isWapView ? (
                <BannerSlider
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              ) : (
                <BannerSliderMobile
                  key={this.props?.sectionData?.items?.banner.tn}
                  data={this.props?.sectionData?.items?.banner}
                  gaAction="ElectionBannerWidget_Click"
                  gaLabelPerfix="election_banner/click/"
                />
              )}
            </div>
          </>
        )}
      </>
    );
  }

  render() {
    return (
      <div className={s.resultlWidgetWrapper} ref={this.ref}>
        {this.props.dataLoading && <LoaderSpinner />}
        {this.state?.currentData &&
          this.state?.currentData?.note && (
            <p className={s.noteText}>{this.state?.currentData?.note}</p>
          )}
        <div className="mt">{this.renderElection()}</div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.lokSabhaElection?.refreshinterval,
  electionData: state?.lokSabhaElection?.electionData,
  dataLoading: state?.lokSabhaElection?.dataLoading,
  starCandidateData: state?.lokSabhaElection?.starCandidateData,
  isExitPoll: state?.lokSabhaElection?.isExitPoll,
  displaytext: state?.lokSabhaElection?.displaytext,
  keywords: state?.lokSabhaElection?.keywords,
  breakingnews: state?.lokSabhaElection?.breakingnews,
  states: state?.lokSabhaElection?.states,
  liveblog: state?.lokSabhaElection?.liveblog,
  datasource: state?.lokSabhaElection?.datasource,
  hideexitheading: state?.lokSabhaElection?.hideexitheading,
  path: state?.lokSabhaElection?.path,
  exitPollStateData: state?.lokSabhaElection?.exitPollStateData,
  sortedData: state?.lokSabhaElection?.sortedData,
  infoMsg: state?.lokSabhaElection?.infoMsg,
  infoMsgCommon: state?.lokSabhaElection?.infoMsgCommon,
  prMasterMap: state?.lokSabhaElection?.prMasterMap,
  alMasterMap: state?.lokSabhaElection?.alMasterMap,
});

const mapDispatchToProps = dispatch => ({
  loadAjaxResultData: (resultObject, loader = false) => {
    dispatch(loadLokSabhaResult(resultObject, loader));
  },
});

LoksabhaElectionStateResultWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
};
LoksabhaElectionStateResultWrapper.defaultProps = {
  isWapView: false,
  data: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoksabhaElectionStateResultWrapper,
);
